import React from 'react';
import { styled } from '@linaria/react';
import { Icon, IconSize } from '@vio/atlas/Icon';
const _exp = /*#__PURE__*/() => Icon;
const MirroredIcon = /*#__PURE__*/styled(_exp())({
  name: "MirroredIcon",
  class: "m1pr4wtr",
  propsAsIs: true
});
interface Props {
  size?: IconSize;
}
export const Chevron = ({
  size = 'sm'
}: Props) => <MirroredIcon name="ChevronRight" size={size} />;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");